import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Logo from './Logo';
import { useRecoilValue } from 'recoil';
import { userState } from '../store/user/userState';
import OptionsUserGuest from './OptionsUserGuest';
import OptionsUserRegistered from './OptionsUserRegistered';
import { preloaderState } from 'src/store/global/preloaderState';


const HeaderApp = () => {
  const user = useRecoilValue(userState);
  const preloader = useRecoilValue(preloaderState);

  if(preloader) return null;

  return (
    <AppBar position="fixed" style={{ borderRadius: 0, }}>
      <Container>
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ mr: 2, display: 'flex', width: '50%', height: '68px' }}
          >
            <Logo />
          </Typography>

          {!user.isAuthenticated && (
            <OptionsUserGuest />
          )}

          {user.isAuthenticated && (
            <OptionsUserRegistered />
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default HeaderApp;